// extracted by mini-css-extract-plugin
export default {"privacy":"Zombie_privacy__VmAIw","listLink":"Zombie_listLink__Idj9v"};